import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalMollie extends React.Component {

  constructor(props) {
    super(props);
    this.state = {plan_active:"2"};

    this.handleSubmit = this.handleSubmit.bind(this);
    this.highlightNew = this.highlightNew.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.shouldShow !== nextProps.shouldShow) {
      this.setState({plan_active:"2"});
    }
  }

  componentDidUpdate() {
    var elements = document.getElementsByClassName("plan");
    for(var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('mouseenter', this.highlightNew);
    }
  }

  highlightNew(e) {
    this.setState({plan_active:e.target.getAttribute("data-id")});
  }


  render() {
    //let per1 = 70.99, per6 = 304.99, per12 = 394.99; original
    let per1 = 31.00, per6 = 132.00, per12 = 180.00;
    if(this.props.shouldShow && this.props.mollie_paymentURL === null) {
      return (
        <ModalWrapper switchState={this.props.close} wrapperClass="medium">
          <form onSubmit={this.handleSubmit}>
            <div>
              <div>
                  <div className="col-2" style={{textAlign:"center"}}>
                    <p style={{margin:"0", fontWeight:"400", fontSize:"2em", lineHeight:"1em", textAlign:"center"}}>Pro</p>
                    <p style={{fontSize:"90%", textAlign:"center"}}>{this.props.i18n_texts["pricing_card_subtitle"][this.props.app_language]}</p>
                  </div>
                  <div className="col-2" style={{marginBottom:"2em"}}>
                    <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp1"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp2"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp3"][this.props.app_language]}}></li>
                      <li dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_card_usp4"][this.props.app_language]}}></li>
                      <li>{this.props.i18n_texts["gen_andmore"][this.props.app_language]}</li>
                    </ul>
                    <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["pricing_card_fairuse"][this.props.app_language]}</small>
                    {/* https://www.e-conomic.com/developer/fair-use-policy In order to maintain optimal performance of our API and ensure that all partners and customers have a good experience we urge all developers to consider and optimize their calls and flows. Fair use is defined as 50.000 API calls per 24 hour period per agreement.<br><br>If an App creates an excessive load on the API, e-conomic is at liberty, without warning, to restrict the integration's access to our APIs, or the affected agreements access to the APIs. e-conomic will offer help and guide on how to optimise the technical implementation.*/}
                  </div>
              </div>
              <div>
                <div id="plans">
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "3") ? "plan active" : "plan"} data-id="3">
                      <h1>1</h1>
                      <p className="months">{this.props.i18n_texts["gen_month"][this.props.app_language]}</p>
                      <h4>€ {per1.toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">&nbsp;</p>
                      <p className="total">€ {(per1 / 30).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "2") ? "plan active" : "plan"} data-id="2">
                      <span className="value-label">{this.props.i18n_texts["gen_recommended"][this.props.app_language]}</span>
                      <h1>6</h1>
                      <p className="months">{this.props.i18n_texts["gen_months"][this.props.app_language]}</p>
                      <h4>€ {(per6 / 6).toFixed(2).toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">{this.props.i18n_texts["gen_save"][this.props.app_language]} {(100 - (per6 / 6 / per1 * 100)).toFixed(0).toString().replace(".", ",")}%</p>
                      <p className="total">€ {(per6 / 182).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                  <div className="plan-container">
                    <div className={(this.state.plan_active === "1") ? "plan active" : "plan"} data-id="1">
                      <span className="value-label">BEST VALUE</span>
                      <h1>12</h1>
                      <p className="months">{this.props.i18n_texts["gen_months"][this.props.app_language]}</p>
                      <h4>€ {(per12 / 12).toFixed(2).toString().replace(".00", "")}/{this.props.i18n_texts["gen_mo"][this.props.app_language]}</h4>
                      <p className="savings">{this.props.i18n_texts["gen_save"][this.props.app_language]} {(100 - (per12 / 12 / per1 * 100)).toFixed(0).toString().replace(".", ",")}%</p>
                      <p className="total">€ {(per12 / 365).toFixed(2).toString().replace(".", ",")}/{this.props.i18n_texts["gen_day"][this.props.app_language]}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div><input type="submit" value={this.props.i18n_texts["core_settings_mollie_continue"][this.props.app_language]} disabled={this.props.mollie_paymentURL_is_fetching} className="btn btn-b btn-fat" style={{margin:".8em 0 0"}} /></div>
          </form>
          <div className="footnote">{this.props.i18n_texts["core_settings_mollie_footnote"][this.props.app_language]}</div>
        </ModalWrapper>
      );
    } else if(this.props.shouldShow && this.props.mollie_paymentURL !== null) {
      let interval = "";
      let total_price = per1;
      if(this.state.plan_active === "2") {
        interval = "6 ";
        total_price = per6;
      } else if(this.state.plan_active === "1") {
        interval = "12 ";
        total_price = per12;
      }
      let month_or_months = this.props.i18n_texts["gen_months"][this.props.app_language];
      if(this.state.plan_active === "3") month_or_months = this.props.i18n_texts["gen_month"][this.props.app_language];
      return (
        <ModalWrapper switchState={this.props.close} wrapperClass="medium">
          <div>
            <p style={{margin:"0", fontWeight:"400", fontSize:"2em", lineHeight:"1em"}}>Pro</p>
            <p style={{fontSize:"90%"}}>{this.props.i18n_texts["pricing_card_subtitle"][this.props.app_language]}</p>
            <p style={{marginBottom:"4px", fontWeight:"400", fontSize:"1.4em", lineHeight:"1em"}}>€ {total_price.toString().replace(".", ",")} per {interval}{month_or_months}</p>
            <small style={{marginBottom:"1em", opacity:".5", display:"block", fontSize:"75%"}}>({this.props.i18n_texts["pricing_card_vat"][this.props.app_language]})</small>
            <p style={{marginBottom:"4px", fontWeight:"400", fontSize:"2em", lineHeight:"1em"}}>€ {(total_price * 1.21).toFixed(2).toString().replace(".", ",")} per {interval}{month_or_months}</p>
            <small style={{marginBottom:"2em", opacity:".5", display:"block", fontSize:"75%"}}>({this.props.i18n_texts["gen_total"][this.props.app_language]})</small>
          </div>
          <p>{this.props.i18n_texts["core_settings_mollie_footnote2"][this.props.app_language]}</p>
          <div style={{textAlign:"right"}}><a href={this.props.mollie_paymentURL} target="_blank" rel="noopener noreferrer" className="btn btn-b btn-fat">{this.props.i18n_texts["gen_buynow"][this.props.app_language]}</a></div>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.props.mollie_paymentURL_is_fetching === false || this.props.mollie_paymentURL_is_fetching === null) {
      let plan_id = 0;
      if(this.state.plan_active === "3") {
        plan_id = 0;
      } else if(this.state.plan_active === "2") {
        plan_id = 1;
      }if(this.state.plan_active === "1") {
        plan_id = 2;
      }
      this.props.fetchDataIfReady(config.api_token, "mollie_paymentURL", "GET", config.api_url+"/EK43Z3VpkjchYBt2?t="+this.props.session_token+"&plan_id="+plan_id);
    }
  }

}


function mapStateToProps(state) {
  let session_token = null, mollie_paymentURL_is_fetching = null, mollie_paymentURL = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["mollie_paymentURL"] !== undefined && state.apiData["mollie_paymentURL"].isFetching !== undefined) {
    mollie_paymentURL_is_fetching = state.apiData["mollie_paymentURL"].isFetching;
    if(state.apiData["mollie_paymentURL"].data !== undefined && state.apiData["mollie_paymentURL"].data.url !== undefined) {
      mollie_paymentURL = state.apiData["mollie_paymentURL"].data.url;
    }
  }
  return {
    session_token: session_token,
    mollie_paymentURL_is_fetching: mollie_paymentURL_is_fetching,
    mollie_paymentURL: mollie_paymentURL,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalMollie)



// WEBPACK FOOTER //
// ./src/containers/ModalMollie.js